import { render } from "./AddValidationTaskPage.vue?vue&type=template&id=4ed34d26&ts=true"
import script from "./AddValidationTaskPage.vue?vue&type=script&lang=ts"
export * from "./AddValidationTaskPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__